import "./sentry/instrument.ts";
import React from "react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./components/AuthContext";
import { AlertProvider } from "./components/AlertContext";
import { UserProvider } from "./components/UserContext";
import { InfoProvider } from "./components/InfoContext";
import { createRoot } from "react-dom/client";
import { Sentry } from "./sentry/instrument";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
    <React.StrictMode>
      <AlertProvider>
        <AuthProvider>
          <InfoProvider>
            <UserProvider>
              <App />
            </UserProvider>
          </InfoProvider>
        </AuthProvider>
      </AlertProvider>
    </React.StrictMode>
  </Sentry.ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
